var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { id: "si-prediction" } },
    [
      !_vm.openMultiple
        ? _c("prediction-tree-grid", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.view === "list",
                expression: "view==='list'"
              }
            ],
            ref: "predictionTreeGrid",
            attrs: {
              context: _vm.context,
              "use-order-center-mode": _vm.useOrderCenterMode,
              "order-center-branch": _vm.useOrderCenterBranch,
              "approve-cooperation-business": _vm.approveCooperationBusiness
            },
            on: {
              look: _vm.lookHandle,
              edit: _vm.editHandle,
              add: _vm.addHandle,
              copy: _vm.copyHandle,
              delete: _vm.deleteHandle,
              batchDelete: _vm.batchDeleteHandler,
              regularBusiness: _vm.regularBusinessHandle
            }
          })
        : _vm._e(),
      _c("prediction-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "predictionWorkspace",
        attrs: {
          "open-multiple": _vm.openMultiple,
          "parent-context": _vm.context,
          "use-order-center-mode": _vm.useOrderCenterMode,
          "approve-cooperation-business": _vm.approveCooperationBusiness
        },
        on: {
          copy: _vm.copyHandle,
          add: _vm.addHandle,
          back: _vm.backToList,
          delete: _vm.deleteHandle,
          regularBusiness: _vm.regularBusinessHandle
        }
      }),
      _c("job-copy-window", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.copyDialog.visible,
            expression: "copyDialog.visible"
          }
        ],
        ref: "jobCopyWindow",
        attrs: {
          visible: _vm.copyDialog.visible,
          lob: _vm.copyDialog.job.lob || ""
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyDialog, "visible", $event)
          },
          confirmCallBack: _vm.confirmCallBackHandler
        }
      }),
      _c("job-no-rule-selector", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.jobNoRule.visible,
            expression: "jobNoRule.visible"
          }
        ],
        ref: "jobCopyWindow",
        attrs: {
          visible: _vm.jobNoRule.visible,
          rules: _vm.jobNoRule.rules || []
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jobNoRule, "visible", $event)
          },
          selectedBack: _vm.doCopyJob
        }
      }),
      _c("sea-im-container-type-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.jobNewDialog.visible,
            expression: "jobNewDialog.visible"
          }
        ],
        ref: "jobNewWindow",
        attrs: {
          visible: _vm.jobNewDialog.visible,
          rules: _vm.jobNewDialog.rules || [],
          "show-rule": _vm.jobNewDialog.showRule
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jobNewDialog, "visible", $event)
          },
          selectedBack: _vm.addHandlerSelect
        }
      }),
      _c("op-verify-frame-confirm-dialog", {
        attrs: {
          visible: _vm.opVerifyFrameConfirmDialog.visible,
          "job-model": _vm.opVerifyFrameConfirmDialog.job,
          "submit-call-back": _vm.opVerifyFrameConfirmDialog.callBack,
          "job-list": _vm.opVerifyFrameConfirmDialog.jobList
        },
        on: { closePageHandler: _vm.closePageHandler }
      }),
      _c("forecast-verify-confirm-dialog", {
        attrs: {
          visible: _vm.forecastVerifyConfirmDialog.visible,
          "job-model": _vm.forecastVerifyConfirmDialog.job,
          "submit-call-back": _vm.forecastVerifyConfirmDialog.callBack
        },
        on: {
          closePageHandler: function($event) {
            _vm.forecastVerifyConfirmDialog.visible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }